module.exports = __webpack_public_path__ + "img/icon_examina.1f4287b0.png";